import React, { Component } from 'react'
import "./Index.scss"
import navData from "app/api/navData.js"
import { Link, withRouter } from "react-router-dom"
import { getCurrentApp } from "app/api/localTools"
import { observer, inject } from "mobx-react"

@inject("auth") @observer
class SideBar extends Component {
  render() {
    const { location } = this.props
    const { userInfo: { roleType } } = this.props.auth
    let navs
    if (roleType) {
      navs = navData[`${roleType}`][getCurrentApp() || 'pgs']
      navs.forEach(item => {
        if (location.pathname.includes(`/${item.href}`) || (item.href === 'overview' && location.pathname.includes('/overview'))) {
          item.className = "active"
        } else {
          item.className = ""
        }
      })
    }
    return (
      <sidebar className="page-sidebar">
        <ul className="page-sidebar-nav">
          {roleType && navs.map((item, index) => (
            <li key={index} className={`${item.className || ""}`} >
              <Link
                to={roleType !== 'research' ?
                  `/jab/main/${getCurrentApp()}/${item.href}` :
                  `/jab/main/research/${getCurrentApp()}/${item.href}`}
              >
                <span className={`sidebar-icon sidebar-icon-${item.icon}`} />
                <span className="sidebar-title">
                  {item.text}
                </span>
              </Link>
            </li>
            
          ))}
          
        </ul>
      </sidebar>
    )
  }
}

export default withRouter(SideBar)



// WEBPACK FOOTER //
// ./src/app/components/common/Sidebar/index.js